<template>
  <div class="income">
    <HeaderReturn :title="particulars.name"></HeaderReturn>
    <div class="main_title">总收益：
        <span>{{ reduce }}</span>
        
    </div>
    <div class="income_ul">
      <ul>
        <van-list
          v-model:loading="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="到底啦~"
          @load="onLoad"
        >
          <li v-for="(item, index) in AccasetList" :key="index">
            <div class="d-flex justify-between">
              <div>
                {{ item.balanceType }}
              </div>
              <div>
                {{ item.createTime }}
              </div>
            </div>
            <div class="d-flex justify-between">
              <div style="color: #f89b19;
">
                数量
                <!-- {{ item.text }} :class="item.amount * 1 > 0 ? 'color-buy' : 'color-sell'"-->
              </div>
              <div style="color: #f89b19;
">
                {{ item.amount }}
              </div>
            </div>
          </li>
        </van-list>
      </ul>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { NoticeBar, Icon, Tab, Tabs, Empty } from "vant";
Vue.use(NoticeBar).use(Icon).use(Tabs).use(Tab).use(Empty);
import vueQr from "vue-qr";
import { mainApiData } from "@/request/api.js";
export default {
  components: {
    vueQr,
  },
  data() {
    return {
      baseApi: "",
      UrlYqhy: "",
      Aeccter: {
        money: 75.8193,
      },

      AccasetList: [],
      performanceList: {
        total: 99999,
        region: 77777,
        plot: 33333,
      },
      particulars: {},
      loading: false,
      finished: false,
      pageNo: 0,
      pageSize: 10,
      reduce: 0,
    };
  },
  created() {
    this.baseApi = process.env.VUE_APP_IMG;
    this.UrlYqhy = window.location.origin + "/#/reg?promotion=" + "1111";
    this.particulars = JSON.parse(this.$route.query.item);
    this.onLoad();
  },
  methods: {
    onLoad() {
      this.pageNo++;
      let parme = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        theTaterType: this.particulars.theTaterType,
      };
      mainApiData.myIncomeDetailed(parme).then((res) => {
        if (res.data.code == 200) {
          for (let i = 0; i < res.data.data.assetsLogPage.records.length; i++) {
            this.AccasetList.push(res.data.data.assetsLogPage.records[i]);
          }
          this.total = res.data.data.assetsLogPage.total;

          this.reduce = res.data.data.reduce;
        }
      });
      this.loading = false;
      if (this.AccasetList.length >= this.total) {
        this.finished = true;
      }
    },
    onCopy() {
      this.$toast(this.$t("myself.a23"));
    },
    goLink(path, item) {
      if (path) {
        this.$router.push({
          path,
          query: {
            item: JSON.stringify(item),
          },
        });
      } else {
        // 暂未开放
        this.$toast(this.$t("orePond.a42"));
      }
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
// 引入全局的样式
@import "@/assets/scss/base.scss";
::v-deep .main_title {
  color: #fff;
  text-align: left;
  font-size: 16px;
  font-family: PingFang SC;
  span{
    color: #f89b19;
  }
}
::v-deep .van-nav-bar__title {
  color: #f89b19 !important;
  font-size: 20px;
  font-weight: 600;
}
.income {
  margin: 50px 10px;

  .df {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: #f89b19;
    font-weight: 600;
    font-size: 20px;
    // margin-top: 150px;
    position: fixed;
    top: 50%;
    left: 0;
    right: 0;
  }

  .income_ul {
    padding: 10px 0;

    ul {
      li {
        // background: rgba(20, 132, 195, 0.2);
        /* 黄/主题 */

        // border-bottom: 0.5px solid #f89b19;
        // box-shadow: 0px 0px 6px 2px rgba(20, 132, 195, 0.25),
        //   inset 0px 0px 6px -2px rgba(20, 132, 195, 0.25);
        border-radius: 4px;
        // display: flex;
        // justify-content: space-between;

        margin: 20px 0;

        div {
          padding: 1px 3px;
          // margin: 0px 0 10px 0;

          // background: rgba(20, 132, 195, 0.2);
          // /* 黄/主题 */

          // border-radius: 4px;
        }

        border: 0.5px solid #f89b19;
        // border: 0.5px solid #f89b19;

        padding: 5px 0;
      }
    }
  }

  .income_tabs {
    ::v-deep .van-tab.van-tab--active {
      background: rgba(20, 132, 195, 0.5);
    }

    ::v-deep .van-tabs__nav--card {
      background: rgba(20, 132, 195, 0.2);
    }

    ::v-deep .van-tabs__nav {
      border-radius: 4px;
    }
  }
}
</style>
